var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_236_5560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6259 18.627 23.9981 11.9971 23.999C5.37206 23.999 -0.000959639 18.6259 5.14575e-07 11.999C-0.00191979 5.37216 5.3711 0 11.999 0C18.627 0 24 5.37312 24 12Z",
    fill: "#878787",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_236_5560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.41125 6.73948C5.41125 6.73948 5.41125 5.41406 6.65504 5.41406C7.76561 5.41406 7.94358 6.53735 7.94358 6.98688V16.9648C7.94358 16.9648 7.98782 18.1992 9.03228 18.1992C10.0767 18.1992 10.3427 17.4792 10.3427 16.3795H17.5634V17.5471C17.5634 17.5471 17.4968 18.5809 16.5637 18.5809H10.5207",
    stroke: "black",
    strokeWidth: 0.6432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1631 11.7656V14.8284",
    stroke: "black",
    strokeWidth: 0.6432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65515 5.41406H13.9638C14.2745 5.41406 15.1634 5.79569 15.1634 6.60473V8.13486",
    stroke: "black",
    strokeWidth: 0.6432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6772 13.8386C12.6772 13.8386 13.8768 11.0525 16.1859 9.1875",
    stroke: "black",
    strokeWidth: 0.6432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4285 6.22185C18.4285 6.22185 17.1623 5.88496 14.9656 8.4242C12.7689 10.9634 13.316 11.8764 13.5631 12.2174C13.8103 12.5584 15.4542 11.862 16.9869 9.83963C18.5195 7.81729 18.8302 6.60399 18.4285 6.22185Z",
    stroke: "black",
    strokeWidth: 0.6432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36536 8.13281H13.3144",
    stroke: "black",
    strokeWidth: 0.6432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36536 9.48047H12.6752",
    stroke: "black",
    strokeWidth: 0.6432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_236_5560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_236_5560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWill);
export default __webpack_public_path__ + "static/media/will.20f9852f171503cdcdaf71e9cd6feb79.svg";
export { ForwardRef as ReactComponent };